import { Injectable } from '@angular/core';
import { AxisInputNumberPipe } from 'axis-components';
import { Utils } from 'axis-ui-generator';
import { CHECKBOXHEADINGLITETravel, CHECKBOXLITEBAG, CHECKBOXLITEPERSONAL_US_CA } from 'src/app/features/fnol/config/fnol-constants';
import { DataStoreService } from 'src/app/features/fnol/services/data-store.service';
import { ClaimtypeAbstractService } from './claimtype-abstract.service';
@Injectable({
  providedIn: 'root'
})
export class ClaimTypeUSService extends ClaimtypeAbstractService {

  momentDateFormat = 'MM-DD-YYYY';
  personalAccident = [];
  permanantdiablity;
  leavebenifit;
  otherClaimShow;
  accidentalDeatBoolean;
  foundmedical;
  policyDetails;
  phoneCodeList;
  insuredDetails = null;
  step2 = 'fnol-claimtype-details';
  step1 = 'fnol-claimant-info';
  country;
  hsotDrInfo = [];
  data;
  uiStructure: any;
  uiData: any;
  constructor(
    public dataStoreService: DataStoreService, public axisPipe: AxisInputNumberPipe
  ) {
    super();
  }

  getClaimTypeData() {
    if (this.dataStoreService.get(this.step2).uiData['claimBenefits'] === 'Travel') {
      return this.getTravelDetails(this.step2);
    }
    else if (this.dataStoreService.get(this.step2).uiData['claimBenefits'] === 'Other') {
      return this.getOtherDetails();
    }

    else if (this.dataStoreService.get(this.step2).uiData['claimBenefits'] === 'Personal Accident') {
      return this.personalAccidentPayload();
    }
  }

  /**
   * Travel icon from step 2
   * @param step
   * @returns
   */
  getTravelDetails(step) {
    const travelDetailsInfo = [];
    travelDetailsInfo.push(
      {
        name: this.getData('claimBenefits', 'label', step)['label'] === 'Select Claim Type' ? 'What is the cause of your claim?' : '',
        value: this.dataStoreService.get(step).uiData['claimBenefits']
      }
    );
    const travelInfo = ['heading', 'dateSymptom', 'dateVisit', 'diagnosisIllness', 'puposeOfYourTrip'];
    const uiData = this.dataStoreService.get(step).uiData;
    travelInfo.forEach(fieldName => {
      if (fieldName === 'heading') {
        travelDetailsInfo.push(
          {
            name: 'Travel Details',
            value: 'heading'
          }
        );
      } else {
        if (fieldName === 'diagnosisIllness' && fieldName.indexOf('diagnosisIllness') > -1) {
          travelDetailsInfo.push(
            {
              name: this.getData('diagnosisIllness', 'label', step)['label'],
              value: this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisIllness']?.name
            }
          );
        } else {
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: this.getData(fieldName, '', step)
            }
          );
        }
      }
    });
    const travelBenefit = ['heading', 'chooseClaimTypeIllness'];
    travelBenefit.forEach(fieldName => {
      if (fieldName === 'heading') {
        travelDetailsInfo.push(
          {
            name: 'Travel Benefits',
            value: 'heading'
          }
        );
      }
      else {
        const newArray = [];
        const chooseClaimType = this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'];
        CHECKBOXHEADINGLITETravel.forEach(field => {
          chooseClaimType.forEach(element => {
            if (field.key === element.name) {
              const dataObj = Utils.getFieldFromStructure(this.uiStructure, element.name);
              const headingValue = dataObj.heading;
              newArray.push(headingValue);
            }
          });
        });
        travelDetailsInfo.push(
          {
            name: this.getData(fieldName, 'label', step)['label'],
            value: newArray.join(', ')
          }
        );
      }
    });

    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'accidentOrIllness') !== undefined) {
      travelDetailsInfo.push(...this.getPersonalAccident('Travel'));
      const DocInfo = this.personalAccident.length === 1 && this.personalAccident?.some(obj => obj === 'Other');
      const hospitalDocInfo = [];
      this.personalAccident.forEach(res => {
        if (res === 'Medical Expense Reimbursement') {
          travelDetailsInfo.push(...this.accidentalMedical('Travel', 'a'));
        }
        if (res === 'Weekly Indemnity (Medical Leave)') {
          travelDetailsInfo.push(...this.mediaclLeave('Travel', 'a'), ...this.detailsMedicalLeave('Travel'));
        }
        if (res === 'Fracture or Dislocation') {
          travelDetailsInfo.push(...this.fractureOrDislocation('Travel'));
        }
        if (res === 'Accidental Death or Dismemberment') {
          travelDetailsInfo.push(...this.accidentalDeath('Travel', 'a'));
        }
        if (res === 'Other') {
          travelDetailsInfo.push(...this.otherDeath('Travel', 'a'));
        }
      });

      if (!DocInfo) {
        hospitalDocInfo.push(...this.hospitalDoctoreInfoPdf('Travel'));
      }
      travelDetailsInfo.push(...hospitalDocInfo);
    }

    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingDelayed') !== undefined) {
      const travelBenefitType = ['heading', 'originalFlightNumber', 'originalArriveDate', 'originalArriveTime', 'revisedFlightNumber', 'actualArriveDate', 'actualArriveTime', 'flightDelayed', 'rebookYourFlight', 'refundOrCredit'];
      travelBenefitType.forEach(fieldName => {
        if (fieldName === 'heading') {
          travelDetailsInfo.push(
            {
              name: 'Delayed Flight',
              value: 'heading'
            }
          );
        } else {
          if (fieldName === 'flightDelayed') {
            if (fieldName.indexOf('flightDelayed') > -1) {
              travelDetailsInfo.push(
                {
                  name: this.getData('flightDelayed', 'label', step)['label'],
                  value: this.getData('flightDelayed', '', step),
                }
              );
            }
            if (this.dataStoreService.get('fnol-claimtype-details').uiData['flightDelayed'].id === '7') {
              travelDetailsInfo.push(
                {
                  name: this.getData('provideDetailsTravel', 'label', step)['label'],
                  value: this.getData('provideDetailsTravel', '', step),
                }
              );
            }
          } else if (fieldName === 'rebookYourFlight') {
            if (uiData['rebookYourFlight'] === 'Yes' && uiData['rebookYourFlight'] !== null) {
              if (uiData['rescheduledFlight'] === 'No' && uiData['rescheduledFlight'] !== null) {
                travelDetailsInfo.push(
                  {
                    name: this.getData('rebookYourFlight', 'label', step)['label'],
                    value: this.getData('rebookYourFlight', '', step),
                  },
                  {
                    name: this.getData('rescheduledFlight', 'label', step)['label'],
                    value: this.getData('rescheduledFlight', '', step),
                  },
                  {
                    name: this.getData('rescheduledFlightDetails', 'label', step)['label'],
                    value: this.getData('rescheduledFlightDetails', '', step),
                  }
                );
              } else {
                travelDetailsInfo.push(
                  {
                    name: this.getData('rebookYourFlight', 'label', step)['label'],
                    value: this.getData('rebookYourFlight', '', step),
                  },
                  {
                    name: this.getData('rescheduledFlight', 'label', step)['label'],
                    value: this.getData('rescheduledFlight', '', step),
                  }
                );
              }
            } else {
              travelDetailsInfo.push({
                name: this.getData('rebookYourFlight', 'label', step)['label'],
                value: this.getData('rebookYourFlight', '', step),
              });
            }
          } else if (fieldName === 'refundOrCredit') {
            if (uiData['refundOrCredit'] === 'Yes' && uiData['refundOrCredit'] !== null) {
              travelDetailsInfo.push(
                {
                  name: this.getData('refundOrCredit', 'label', step)['label'],
                  value: this.getData('refundOrCredit', '', step),
                },
                {
                  name: this.getData('refundCreditAmount', 'label', step)['label'],
                  value: this.checkCustom('refundCreditAmount', '', step, this.axisPipe),
                }
              );
            } else {
              travelDetailsInfo.push({
                name: this.getData('refundOrCredit', 'label', step)['label'],
                value: this.getData('refundOrCredit', '', step),
              });
            }
          } else {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step),
              }
            );
          }
        }
      });

      const addDelayedFlight = Utils.getFieldFromStructure(this.dataStoreService.get(this.step2).uiStructure, 'addDelayedFlightMain').fields;
      addDelayedFlight.forEach((card) => {
      card.fields.forEach((data, i) => {
        data?.fields?.forEach((item) => {
          if (item.name.match('expenseAmount')) {
            travelDetailsInfo.push({
              'name': this.getData(item.name, 'label', this.step2)['label'],
              'value': this.checkCustom(item.name, '', this.step2, this.axisPipe)
            });
          } else {
            travelDetailsInfo.push({
              'name': this.getData(item.name, 'label', this.step2)['label'],
              'value': this.getData(item.name, '', this.step2)
            });
          }
        });
      });
      });
    }

    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingTrip') !== undefined) {
      const travelBenefitType = ['heading', 'tripCancelledInteruptedRadio', 'prepaidTravelRadio', 'diagnosisSickTripSick', 'diagnosisSickTripShip', 'diagnosisTripOtherShip', 'claimingForOther', 'dateOfCancellation', 'flightExpense', 'flightRefund', 'accommodationExpense', 'accommodationRefund', 'transportationExpense', 'transportationRefund', 'otherExpense', 'otherRefund'];
      const travelBenefitInterrupted = [
        'heading', 'tripCancelledInteruptedRadio', 'prepaidTravelRadio', 'diagnosisSickTripSickIntrpt', 'diagnosisSickTripShipIntrpt', 'diagnosisTripOtherShipIntrpt', 'claimingForOtherIntrpt', 'dateOfCancellationIntrpt', 'flightExpenseIntrpt', 'flightRefundIntrpt', 'accommodationExpenseIntrpt', 'accommodationRefundIntrpt', 'transportationExpenseIntrpt', 'transportationRefundIntrpt', 'otherExpenseIntrpt', 'otherRefundIntrpt'
      ];
      if (this.dataStoreService.get(this.step2)['uiData']['tripCancelledInteruptedRadio'] === 'Cancelled') {
        travelBenefitType.forEach(fieldName => {
          if (fieldName === 'heading') {
            travelDetailsInfo.push(
              {
                name: 'Cancelled or Interrupted Trip',
                value: 'heading'
              }
            );
          } else if (fieldName === 'tripCancelledInteruptedRadio') {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.checkCustom(fieldName, '', step, this.axisPipe)
              }
            );
          } else {
            if (this.dataStoreService.get(this.step2)['uiData']['prepaidTravelRadio'] === 'Yes') {
              if (fieldName === 'flightExpense' || fieldName === 'flightRefund' || fieldName === 'accommodationExpense' || fieldName === 'accommodationRefund' || fieldName === 'transportationExpense' || fieldName === 'transportationRefund' || fieldName === 'otherExpense' || fieldName === 'otherRefund') {
                travelDetailsInfo.push(
                  {
                    name: this.getData(fieldName, 'label', step)['label'],
                    value: this.checkCustom(fieldName, '', step, this.axisPipe)
                  }
                );
              }
              if (fieldName === 'tripCancelledInteruptedRadio') {
                travelDetailsInfo.push(
                  {
                    name: this.getData(fieldName, 'label', step)['label'],
                    value: this.checkCustom(fieldName, '', step, this.axisPipe)
                  }
                );
              }

              if (fieldName === 'diagnosisSickTripSick') {
                travelDetailsInfo.push(
                  {
                    name: this.getData('diagnosisSickTripSick', 'label', step)['label'],
                    value: this.getData('diagnosisSickTripSick', '', step),
                  }
                );
                const diagnosisSickTripSick = this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisSickTripSick'];
                if (diagnosisSickTripSick.id === '7') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData('diagnosisTripOtherSick', 'label', step)['label'],
                      value: this.getData('diagnosisTripOtherSick', '', step),
                    }
                  );
                }

                if (diagnosisSickTripSick.id === '4') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData('diagnosisSickTripShip', 'label', step)['label'],
                      value: this.getData('diagnosisSickTripShip', '', step),
                    }
                  );
                  if (this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisSickTripShip']?.id === '8') {
                    travelDetailsInfo.push(
                      {
                        name: this.getData('diagnosisTripOtherShip', 'label', step)['label'],
                        value: this.getData('diagnosisTripOtherShip', '', step),
                      }
                    );
                  }
                }
              }
              if (fieldName === 'claimingForOther' || fieldName === 'dateOfCancellation') {
                travelDetailsInfo.push(
                  {
                    name: this.getData(fieldName, 'label', step)['label'],
                    value: this.getData(fieldName, '', step),
                  }
                );
              }
            }

          }

          if (fieldName === 'prepaidTravelRadio') {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step)
              }
            );
          }
        });
      }

      else if (this.dataStoreService.get(this.step2)['uiData']['tripCancelledInteruptedRadio'] === 'Interrupted') {
        travelBenefitInterrupted.forEach(fieldName => {
          if (fieldName === 'heading') {
            travelDetailsInfo.push(
              {
                name: 'Cancelled or Interrupted Trip',
                value: 'heading'
              }
            );
          } else if (fieldName === 'tripCancelledInteruptedRadio') {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.checkCustom(fieldName, '', step, this.axisPipe)
              }
            );
          } else {
            if (fieldName === 'flightExpenseIntrpt' || fieldName === 'flightRefundIntrpt' || fieldName === 'accommodationExpenseIntrpt' || fieldName === 'accommodationRefundIntrpt' || fieldName === 'transportationExpenseIntrpt' || fieldName === 'transportationRefundIntrpt' || fieldName === 'otherExpenseIntrpt' || fieldName === 'otherRefundIntrpt') {
              travelDetailsInfo.push(
                {
                  name: this.getData(fieldName, 'label', step)['label'],
                  value: this.checkCustom(fieldName, '', step, this.axisPipe)
                }
              );
            }

            if (fieldName === 'tripCancelledInteruptedRadio') {
              travelDetailsInfo.push(
                {
                  name: this.getData(fieldName, 'label', step)['label'],
                  value: this.checkCustom(fieldName, '', step, this.axisPipe)
                }
              );
            }

            if (fieldName === 'diagnosisSickTripSickIntrpt') {
              travelDetailsInfo.push(
                {
                  name: this.getData('diagnosisSickTripSickIntrpt', 'label', step)['label'],
                  value: this.getData('diagnosisSickTripSickIntrpt', '', step),
                }
              );
              const diagnosisSickTripSickIntrpt = this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisSickTripSickIntrpt'];
              if (diagnosisSickTripSickIntrpt.id === '7') {
                travelDetailsInfo.push(
                  {
                    name: this.getData('diagnosisTripOtherSickIntrpt', 'label', step)['label'],
                    value: this.getData('diagnosisTripOtherSickIntrpt', '', step),
                  }
                );
              }

              if (diagnosisSickTripSickIntrpt.id === '4') {
                travelDetailsInfo.push(
                  {
                    name: this.getData('diagnosisSickTripShipIntrpt', 'label', step)['label'],
                    value: this.getData('diagnosisSickTripShipIntrpt', '', step),
                  });
                if (this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisSickTripShipIntrpt']?.id === '8') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData('diagnosisTripOtherShipIntrpt', 'label', step)['label'],
                      value: this.getData('diagnosisTripOtherShipIntrpt', '', step),
                    }
                  );
                }
              }
            }

            if (fieldName === 'claimingForOtherIntrpt' || fieldName === 'dateOfCancellationIntrpt') {
              travelDetailsInfo.push(
                {
                  name: this.getData(fieldName, 'label', step)['label'],
                  value: this.getData(fieldName, '', step),
                }
              );
            }
          }
        });
      }
    }

    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingLost') !== undefined) {
      const travelBenefitType = ['heading', 'itemClaimType'];
      travelBenefitType.forEach(fieldName => {
        if (fieldName === 'heading') {
          travelDetailsInfo.push(
            {
              name: 'Baggage / Item Claim',
              value: 'heading'
            }
          );
        } else {
          const newArray = [];
          const chooseClaimType = this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'];
          CHECKBOXLITEBAG.forEach(field => {
            chooseClaimType.forEach(element => {
              if (field.key === element.name) {
                const headingValue = field.heading;
                newArray.push(headingValue);
              }
            });
          });
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: newArray.join(', ')
            }
          );
        }
      });

      const travelBagsDetails = ['travelBags'];
      travelBagsDetails.forEach(fieldName => {
        if (fieldName === 'travelBags') {
          travelDetailsInfo.push(
            {
              name: this.getData('travelBags', 'label', step)['label'],
              value: this.getData('travelBags', '', step),
            }
          );
          if (uiData['travelBags'] === 'Delayed') {
            const delayedDetails = ['landDate', 'timeLand', 'returnedDate', 'timeReturned'];
            delayedDetails.forEach(delayedDetail => {
              travelDetailsInfo.push(
                {
                  name: this.getData(delayedDetail, 'label', step)['label'],
                  value: this.getData(delayedDetail, '', step),
                }
              );
            });

            if (uiData['delayedAuthorityReport'] === 'Yes' && uiData['delayedAuthorityReport'] !== null) {
              travelDetailsInfo.push(
                {
                  name: this.getData('delayedAuthorityReport', 'label', step)['label'],
                  value: this.checkCustom('delayedAuthorityReport', '', step, this.axisPipe)
                },
                {
                  name: this.getData('delayedAuthorityReportCopy', 'label', step)['label'],
                  value: this.checkCustom('delayedAuthorityReportCopy', '', step, this.axisPipe)
                }
              );
            } else {
              travelDetailsInfo.push(
                {
                  name: this.getData('delayedAuthorityReport', 'label', step)['label'],
                  value: this.checkCustom('delayedAuthorityReport', '', step, this.axisPipe)
                }
              );
            }

            if (uiData['delayedAuthorityReport'] === 'Yes' && uiData['delayedAuthorityReport'] !== null) {
              const copyReport = ['delayedReportAuthorityName', 'delayedReportReferenceNumber', 'delayedPhoneNumber', 'emailDelayed', 'delayedAddressLookup'];
              copyReport.forEach(copyReportField => {
                if (copyReportField === 'delayedAddressLookup') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(copyReportField, 'label', step)['label'],
                      value: this.dataStoreService.checkAutoComplete(this.getData(copyReportField + 'val', '', step) ? this.getData(copyReportField + 'val', '', step) : this.getData(copyReportField, '', step).formatted_address ? this.getData(copyReportField, '', step).formatted_address : this.getData(copyReportField, '', step))
                    }
                  );
                } else if (copyReportField === 'delayedPhoneNumber' && this.dataStoreService.get(this.step2)['uiData']['delayedPhoneNumber'] !== null) {
                  travelDetailsInfo.push(
                    {
                      name: 'Phone Number',
                      value: this.phoneNumberValidation('delayedPhoneNumber')
                    }
                  );
                } else {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(copyReportField, 'label', step)['label'],
                      value: this.checkCustom(copyReportField, '', step, this.axisPipe)
                    }
                  );
                }
              });
            }
          }

          if (uiData['travelBags'] === 'Damaged') {
            const delayedDetails = ['bagsTripSick', 'damagedDate', 'provideDetails', 'heading']
            delayedDetails.forEach(delayedDetailsfield => {
              if (delayedDetailsfield === 'heading') {
                travelDetailsInfo.push(
                  {
                    name: 'Bags and/or Items Details',
                    value: 'heading'
                  }
                );
              } 
              if (delayedDetailsfield === 'bagsTripSick') {
                if (delayedDetailsfield.indexOf('bagsTripSick') > -1) {
                  travelDetailsInfo.push(
                    {
                      name: this.getData('bagsTripSick', 'label', step)['label'],
                      value: this.getData('bagsTripSick', '', step),
                    }
                  );
                }
                if (this.dataStoreService.get('fnol-claimtype-details').uiData['bagsTripSick'].id === '3') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData('otherBagsTripSick', 'label', step)['label'],
                      value: this.getData('otherBagsTripSick', '', step),
                    }
                  );
                }
              } else {
                travelDetailsInfo.push(
                  {
                    name: this.getData(delayedDetailsfield, 'label', step)['label'],
                    value: this.getData(delayedDetailsfield, '', step),
                  }
                );
              }
            });

            if (this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][0]?.name === 'myBags' || ((this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][0]?.name === 'myBags' && this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][1]?.name === 'myItems') || (this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][1]?.name === 'myBags' && this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][0]?.name === 'myItems'))) {
              const bagDamage = Utils.getFieldFromStructure(this.dataStoreService.get(this.step2).uiStructure, 'addItemsMain').fields;
              let tempArray = [];
              bagDamage.forEach((card) => {
              card.fields.forEach((data, i) => {
                data?.fields?.forEach((item) => {
                  if (item.name.match('nameValue') || item.name.match('repairCost')) {
                    if (this.getData(item.name, '', this.step2)) {
                      tempArray.push({
                        'name': this.getData(item.name, 'label', this.step2)['label'],
                        'value': this.checkCustom(item.name, '', this.step2, this.axisPipe)
                      });
                    }
                  } else {
                    if (this.getData(item.name, '', this.step2)) {
                      tempArray.push({
                        'name': this.getData(item.name, 'label', this.step2)['label'],
                        'value': this.getData(item.name, '', this.step2)
                      });
                    }
                  }
                });
                // Removed logic that pops items from tempArray to ensure all fields, including repairCost, are shown
                travelDetailsInfo.push(...tempArray);
                tempArray = [];
              });
              });
            } else if (this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][0]?.name === 'myItems') {
              const bagDamage = Utils.getFieldFromStructure(this.dataStoreService.get(this.step2).uiStructure, 'addItemsMain').fields;
              bagDamage.forEach((card) => {
              card.fields.forEach((data, i) => {
                data?.fields?.forEach((item) => {
                  if (item.name.match('nameValue')) {
                    if (this.getData(item.name, '', this.step2)) {
                      travelDetailsInfo.push({
                        'name': this.getData(item.name, 'label', this.step2)['label'],
                        'value': this.checkCustom(item.name, '', this.step2, this.axisPipe)
                      });
                    }
                  } else if (item.name.match('bagItem') || item.name.match('yearPurchased')) {
                    if (this.getData(item.name, '', this.step2)) {
                      travelDetailsInfo.push({
                        'name': this.getData(item.name, 'label', this.step2)['label'],
                        'value': this.getData(item.name, '', this.step2)
                      });
                    }
                  }
                });
              });
              });
            }

            if (uiData['damagedAuthorityReport'] === 'Yes' && uiData['damagedAuthorityReport'] !== null) {
              travelDetailsInfo.push(
                {
                  name: this.getData('damagedAuthorityReport', 'label', step)['label'],
                  value: this.checkCustom('damagedAuthorityReport', '', step, this.axisPipe)
                },
                {
                  name: this.getData('damagedAuthorityReportCopy', 'label', step)['label'],
                  value: this.checkCustom('damagedAuthorityReportCopy', '', step, this.axisPipe)
                }
              );
            } else {
              travelDetailsInfo.push(
                {
                  name: this.getData('damagedAuthorityReport', 'label', step)['label'],
                  value: this.checkCustom('damagedAuthorityReport', '', step, this.axisPipe)
                }
              );
            }

            if (uiData['damagedAuthorityReport'] === 'Yes' && uiData['damagedAuthorityReport'] !== null) {
              const copyReport = ['damagedReportAuthorityName', 'damagedReportReferenceNumber', 'damagedPhoneNumber', 'emailDamaged', 'damagedAddressLookup'];
              copyReport.forEach(copyReportfield => {
                if (copyReportfield === 'damagedAddressLookup') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(copyReportfield, 'label', step)['label'],
                      value: this.dataStoreService.checkAutoComplete(this.getData(copyReportfield + 'val', '', step) ? this.getData(copyReportfield + 'val', '', step) : this.getData(copyReportfield, '', step).formatted_address ? this.getData(copyReportfield, '', step).formatted_address : this.getData(copyReportfield, '', step))
                    }
                  );
                } else if (copyReportfield === 'damagedPhoneNumber' && this.dataStoreService.get(this.step2)['uiData']['damagedPhoneNumber'] !== null) {
                  travelDetailsInfo.push(
                    {
                      name: 'Phone Number',
                      value: this.phoneNumberValidation('damagedPhoneNumber')
                    }
                  );
                } else {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(copyReportfield, 'label', step)['label'],
                      value: this.checkCustom(copyReportfield, '', step, this.axisPipe)
                    }
                  );
                }
              });
            }
          }

          if (uiData['travelBags'] === 'Lost or Stolen') {
            const lostStolenDetails = ['stolenLost', 'stolenHappened', 'stolenItem', 'stolenItemWas', 'stolenDate', 'heading'];
            lostStolenDetails.forEach(fieldsName => {
              if (fieldsName === 'heading') {
                travelDetailsInfo.push(
                  {
                    name: 'Bags and/or Items Details',
                    value: 'heading',
                  }
                );
              } else {
                travelDetailsInfo.push(
                  {
                    name: this.getData(fieldsName, 'label', step)['label'],
                    value: this.getData(fieldsName, '', step),
                  }
                );
              }
            });

            const lostStolen = Utils.getFieldFromStructure(this.dataStoreService.get(step).uiStructure, 'addStolenMain').fields;
            lostStolen.forEach((card) => {
            card.fields.forEach((data, i) => {
              const matches = data.name.match(/(\d+)/);
              const index1 = matches !== null ? matches[0] : '';
              const stolenDetails = ['bagItemStolen', 'nameStolenValue', 'yearStolenPurchased', 'heading'];
              stolenDetails.forEach((item) => {
                if (item === 'nameStolenValue') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(item + index1, 'label', step)['label'],
                      value: this.checkCustom(item + index1, '', step, this.axisPipe)
                    }
                  );
                } else if (item === 'heading') {
                  travelDetailsInfo.push(
                    {
                      name: '',
                      value: 'heading'
                    }
                  );
                } else {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(item + index1, 'label', step)['label'],
                      value: this.getData(item + index1, '', step)
                    }
                  );
                }
              });
            });
            });

            if (uiData['authorityReport'] === 'Yes' && uiData['authorityReport'] !== null) {
              travelDetailsInfo.push(
                {
                  name: this.getData('authorityReport', 'label', step)['label'],
                  value: this.checkCustom('authorityReport', '', step, this.axisPipe)
                },
                {
                  name: this.getData('authorityCopyReport', 'label', step)['label'],
                  value: this.checkCustom('authorityCopyReport', '', step, this.axisPipe)
                }
              );
            } else {
              travelDetailsInfo.push(
                {
                  name: this.getData('authorityReport', 'label', step)['label'],
                  value: this.checkCustom('authorityReport', '', step, this.axisPipe)
                }
              );
            }

            if (uiData['authorityReport'] === 'Yes' && uiData['authorityReport'] !== null) {
              const copyReport = ['nameAuthority', 'referenceNumber', 'phoneNumber', 'emailStolen', 'myAddressLookup']
              copyReport.forEach(item => {
                if (item === 'myAddressLookup') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(item, 'label', step)['label'],
                      value: this.dataStoreService.checkAutoComplete(this.getData(item + 'val', '', step) ? this.getData(item + 'val', '', step) : this.getData(item, '', step).formatted_address ? this.getData(item, '', step).formatted_address : this.getData(item, '', step))
                    }
                  );
                } else if (item === 'phoneNumber' && this.dataStoreService.get(this.step2)['uiData']['phoneNumber'] !== null) {
                  travelDetailsInfo.push(
                    {
                      name: 'Phone Number',
                      value: this.phoneNumberValidation('phoneNumber')
                    });
                } else {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(item, 'label', step)['label'],
                      value: this.checkCustom(item, '', step, this.axisPipe)
                    }
                  );
                }
              });
            }
          }
        }
      });
    }

    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingOther') !== undefined) {
      const travelBenefitType = ['heading', 'claimingForOtherFor','travelIncidentDate'];
      travelBenefitType.forEach(fieldName => {
        if (fieldName === 'heading') {
          travelDetailsInfo.push(
            {
              name: 'Other',
              value: 'heading'
            }
          );
        } else {
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: this.getData(fieldName, '', step),
            }
          );
        }
      });
    }
    return travelDetailsInfo.filter(e => (e.name !== undefined && e.name !== null));
  }

  /**
   * Personal Accident icon
   * @returns
   */
  personalAccidentPayload() {
    let personalPayLoad = [];
    let hospitalDocInfoIsPresent = false;
    personalPayLoad = personalPayLoad.concat(this.getPersonalAccident(''));
    console.log('PPAYLOAD', personalPayLoad)
    this.personalAccident.forEach(res => {
      if (res === 'Medical Expense Reimbursement') {
        personalPayLoad = personalPayLoad.concat(this.accidentalMedical('', 'a'));
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Permanent or Temporary Disablement') {
        personalPayLoad = personalPayLoad.concat(this.PermanentDisablement('a'));
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Hospital Cash') {
        personalPayLoad = personalPayLoad.concat(this.hospitalCash('a'));
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Weekly Indemnity (Medical Leave)') {
        personalPayLoad = personalPayLoad.concat(this.mediaclLeave('', 'a'), this.detailsMedicalLeave(''));
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Fracture or Dislocation') {
        personalPayLoad = personalPayLoad.concat(this.fractureOrDislocation(''));
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Accidental Death or Dismemberment') {
        personalPayLoad = personalPayLoad.concat(this.accidentalDeath('', 'a'));
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Critical Illness') {
        personalPayLoad = personalPayLoad.concat(this.criticalIllness('a'), this.getPhysicianInfo(), this.getCriticalHospital());
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Other') {
        personalPayLoad = personalPayLoad.concat(this.otherDeath('', 'a'));
      }
    });
    if (hospitalDocInfoIsPresent) {
      personalPayLoad = personalPayLoad.concat(this.hospitalDoctoreInfoPdf(''));
    }
    return personalPayLoad;
  }

  /**
   *
   * @returns
   */
  hospitalDoctoreInfoPdf(type) {
    return this.hospitalDoctorInfo(type);
  }

  drInfor() {
    const personalAccidentDetailsInfo = this.captureData('doctorInfo');
    this.hsotDrInfo = personalAccidentDetailsInfo;
    return personalAccidentDetailsInfo;
  }

  /**
  *
  * @param e
  * @returns
  */
  accidentalMedical(type, e?) {
    let DetailsData = [];
    DetailsData = this.getMedicalExpense(type);
    if (DetailsData.length > 1) {
      const array = [{
        name: 'Medical Expense Reimbursement',
        value: 'heading'
      }];
      DetailsData = [...array, ...DetailsData];
    } else {
      DetailsData = [];
    }
    return DetailsData.filter(element => (element.name !== undefined));
  }

  /**
   *
   * @returns medical expense array
   */
  getMedicalExpense(type) {
    const medicalExpenseInfo = Utils.getFieldFromStructure(this.uiStructure, `addMedicalExpense${type}Main`).fields;
    const medicalExpenseArray = [];
    const uiData = this.dataStoreService.get(this.step2).uiData;
    medicalExpenseInfo.forEach((card) => {
      card.fields.forEach((data) => {
      data?.fields?.forEach((item) => {
        if (this.getData(item.name, '', this.step2) !== null) {
          if (item.name.indexOf(`OtherDetail${type}`) === -1) {
            medicalExpenseArray.push({
              'name': this.getData(item.name, 'label', this.step2)['label'],
              'value': item.name.includes(`expenseAmountMedExp${type}`) ? this.checkCustom(item.name, '', this.step2, this.axisPipe) : this.getData(item.name, '', this.step2)
            });
          } else if (item.name.indexOf(`OtherDetail${type}`) !== -1 && uiData[data?.fields?.find(x => x.type === 'dropdown').name].name === 'Other') {
            medicalExpenseArray.push({
              'name': this.getData(item.name, 'label', this.step2)['label'],
              'value': this.getData(item.name, '', this.step2)
            });
          }
        }
      });
    });
    });
    const filteredArray = medicalExpenseArray.filter(e => !(e.value === '' && e.name === 'Please provide details') && (e.name !== undefined));
    return filteredArray;
  }

  /**
   *
   * @returns
   */
  getPersonalAccident(type) {
    const personalDetails = [];
    const uiData = this.dataStoreService.get(this.step2).uiData;
    if (type === '') {
      personalDetails.push(
        {
          name: this.getData('claimBenefits', 'label', this.step2)['label'] === 'Select Claim Type' ? 'What is the cause of your claim?' : '',
          value: 'Accident & Illness'
        }
      );
    }
    const arrysub1 = ['heading', 'illnessOccur', `accidentOccurred${type}`, `injuriesSustained${type}`, `accidentDate${type}`, `timeIncident${type}`, `accidentLocationLookup${type}`, `medicalAttention${type}`, `firstVisit${type}`, `diagnosis${type}`, `trafficAccident${type}`,
      `similarConditionPast${type}`, `doctorsName${type}`, `doctorsStreetAddressLookup${type}`, `doctorsContactNumber${type}`, 'travelAffectedTravel'];
    const arraysub2 = ['heading', `chooseClaimType${type}`];
    arrysub1.forEach(key => {
      if (key === 'heading') {
        if (type === 'Travel') {
          personalDetails.push(
            {
              name: 'Accident or Illness',
              value: 'heading'
            }
          );
        } else {
          personalDetails.push(
            {
              name: 'Personal Accident & Illness Details',
              value: 'heading'
            }
          );
        }
      } else if (key === `accidentLocationLookup${type}`) {
        if (this.getData(key, '', this.step2)) {
          personalDetails.push(
            {
              name: this.getData(key, 'label', this.step2)['label'],
              value: this.dataStoreService.checkAutoComplete(this.getData(key + 'val', '', this.step2) ? this.getData(key + 'val', '', this.step2) : this.getData(key, '', this.step2).formatted_address ? this.getData(key, '', this.step2).formatted_address : this.getData(key, '', this.step2))
            }
          );
        }
      }

      else if (key === `similarConditionPast${type}`) {
        if (uiData[`similarConditionPast${type}`] === 'Yes' && uiData[`similarConditionPast${type}`] !== null) {
          personalDetails.push(
            {
              name: this.getData(`similarConditionPast${type}`, 'label', this.step2)['label'],
              value: this.getData(`similarConditionPast${type}`, '', this.step2),
            },
            {
              name: this.getData(`provideDetailsSimilarConditionPast${type}`, 'label', this.step2)['label'],
              value: this.getData(`provideDetailsSimilarConditionPast${type}`, '', this.step2),
            }
          );
        } else {
          personalDetails.push({
            name: this.getData(`similarConditionPast${type}`, 'label', this.step2)['label'],
            value: this.getData(`similarConditionPast${type}`, '', this.step2),
          });
        }
      }

      else if (key === 'travelAffectedTravel' && type === 'Travel') {
        if (uiData['travelAffectedTravel'] === 'Yes' && uiData['travelAffectedTravel'] !== null) {
          personalDetails.push(
            {
              name: this.getData('travelAffectedTravel', 'label', this.step2)['label'],
              value: this.getData('travelAffectedTravel', '', this.step2),
            },
            {
              name: this.getData('whatWasAffectedTravel', 'label', this.step2)['label'],
              value: this.getData('whatWasAffectedTravel', '', this.step2),
            },
            {
              name: this.getData('howMuchCostTravel', 'label', this.step2)['label'],
              value: this.checkCustom('howMuchCostTravel', '', this.step2, this.axisPipe),
            }
          );
        } else {
          personalDetails.push({
            name: this.getData('travelAffectedTravel', 'label', this.step2)['label'],
            value: this.getData('travelAffectedTravel', '', this.step2),
          });
        }
      }

      else if (key === 'illnessOccur' && type === '') {
        personalDetails.push({
          name: this.getData('illnessOccur', 'label', this.step2)['label'],
          value: this.getData('illnessOccur', '', this.step2),
        });
      }

      else if (key === `doctorsStreetAddressLookup${type}`) {
        if (this.getData(key, '', this.step2)) {
          personalDetails.push(
            {
              name: this.getData(key, 'label', this.step2)['label'],
              value: this.getData(key + 'val', '', this.step2) ? this.getData(key + 'val', '', this.step2) : this.getData(key, '', this.step2).formatted_address ? this.getData(key, '', this.step2).formatted_address : this.getData(key, '', this.step2)
            }
          );
        }
      } else if (key === `doctorsContactNumber${type}`) {
        if (uiData[`doctorsContactNumber${type}`] !== null) {
          const docPhone = type === 'Travel' ? 'doctorsContactNumberTravel' : 'doctorsContactNumber';
          personalDetails.push(
            {
              name: this.getData(`doctorsContactNumber${type}`, 'label', this.step2)['label'],
              value: this.phoneNumberValidation(docPhone)
            },
          );
        } else {
          personalDetails.push({
            name: this.getData(`doctorsContactNumber${type}`, 'label', this.step2)['label'],
            value: this.getData(`doctorsContactNumber${type}`, '', this.step2),
          });
        }
      }


      else if ((key === `injuriesSustained${type}`) || (key === `firstVisit${type}`) || (key === `timeIncident${type}`)) {
        personalDetails.push(
          {
            name: this.getData(key, 'label', this.step2)['label'],
            value: this.getData(key, '', this.step2)
          }
        );
      }

      else if (key === `diagnosis${type}`) {
        if (key.indexOf(`diagnosis${type}`) > -1) {
          personalDetails.push(
            {
              name: this.getData(`diagnosis${type}`, 'label', this.step2)['label'],
              value: this.getData(`diagnosis${type}`, '', this.step2),
            }
          );
        }
        if (this.dataStoreService.get('fnol-claimtype-details').uiData[`diagnosis${type}`]?.id === '13') {
          personalDetails.push(
            {
              name: this.getData(`otherDia${type}`, 'label', this.step2)['label'],
              value: this.getData(`otherDia${type}`, '', this.step2),
            }
          );
        }
      } else {
        if (this.dataStoreService.get(this.step2)?.uiData[key] !== `diagnosis${type}`) {
          if (this.getData(key, '', this.step2)) {
            personalDetails.push(
              {
                name: this.getData(key, 'label', this.step2)['label'],
                value: this.getData(key, '', this.step2)
              }
            );
          }
        }
      }
    });

    arraysub2.forEach(key => {
      if (key === 'heading') {
        if (type === 'Travel') {
          personalDetails.push(
            {
              name: 'Accident or Illness',
              value: 'heading'
            }
          );
        } else {
          personalDetails.push(
            {
              name: 'Personal Accident & Illness Benefits',
              value: 'heading'
            }
          );
        }
      } else {
        const newArray = [];
        this.personalAccident = [];
        const chooseClaim = type === 'Travel' ? 'chooseClaimTypeTravel' : 'chooseClaimType';
        const claimType = type === 'Travel' ? 'Travel' : '';
        const chooseClaimType = this.dataStoreService.get('fnol-claimtype-details').uiData[chooseClaim];
        CHECKBOXLITEPERSONAL_US_CA.forEach(field => {
          chooseClaimType.forEach(element => {
            if (field.key + claimType === element.name) {
              const dataObj = Utils.getFieldFromStructure(this.uiStructure, element.name);
              const headingValue = dataObj.heading;
              newArray.push(headingValue);
              this.personalAccident.push(headingValue);
            }
          });
        });
        personalDetails.push(
          {
            name: this.getData(key, 'label', this.step2)['label'],
            value: newArray.join(', ')
          }
        );
      }
    });
    return personalDetails.filter(e => (e.name !== undefined && e.name !== null));
  }

  /**
   * Others Icon
   * @returns
   */
  getOtherDetails() {
    return this.getOtherDetailsData('claimForOther', 'otherDate');
  }

  mediaclLeave(type, e?) {
    return this.mediaclLeaveData('Weekly Indemnity', type, e);
  }

  detailsMedicalLeave(type) {
    const personalAccidentDetails = [`employed${type}`, `dateOfExpected${type}`];
    let personalAccidentDetailsInfo = [];
    personalAccidentDetailsInfo = this.captureData(personalAccidentDetails);
    return personalAccidentDetailsInfo;
  }

  PermanentDisablement(e?) {
    return this.PermanentDisablementData(e);
  }

  /**
   * To capture data from the Accidental Death or Dismemberment section.
   * @param e
   * @returns Array of data related to Accidental Death or Dismemberment section.
   */
  accidentalDeath(type, e?) {
    let disablityData = [];
    const uiData = this.dataStoreService.get(this.step2).uiData;
    if (uiData[`deathOrDismemberment${type}`] === 'Death' && uiData[`deathOrDismemberment${type}`] !== null) {
      const permanentDi = [`deathOrDismemberment${type}`, `dateOfDeath${type}`, `localTimePersonal${type}`, `causeDeath${type}`, `autopsy${type}`, `fullName${type}`, `relationName${type}`, `phoneNumberPersonal${type}`, `emailAddress${type}`];
      permanentDi.forEach((res) => {
        if (res === `phoneNumberPersonal${type}`) {
          const data = this.getData(`phoneNumberPersonal${type}`, '', this.step2);
          if (data) {
            disablityData.push(
              {
                'name': 'Phone Number',
                'value': this.phoneNumberValidation(`phoneNumberPersonal${type}`)
              }
            );
          }
        } else if (res === `autopsy${type}`) {
          if (uiData[`autopsy${type}`] === 'No' && uiData[`autopsy${type}`] !== null) {
            disablityData.push(
              {
                name: this.getData(`autopsy${type}`, 'label', this.step2)['label'],
                value: this.getData(`autopsy${type}`, '', this.step2),
              },
              {
                name: this.getData(`reason${type}`, 'label', this.step2)['label'],
                value: this.getData(`reason${type}`, '', this.step2),
              }
            );
          } else {
            disablityData.push({
              name: this.getData(`autopsy${type}`, 'label', this.step2)['label'],
              value: this.getData(`autopsy${type}`, '', this.step2),
            });
          }
        } else {
          if (this.getData(res, '', this.step2) || res === `localTimePersonal${type}`) {
            disablityData.push(
              {
                name: this.getData(res, 'label', this.step2)['label'],
                value: this.getData(res, '', this.step2)
              }
            );
          }
        }
      });
    } else if (uiData[`deathOrDismemberment${type}`] === 'Dismemberment' && uiData[`deathOrDismemberment${type}`] !== null) {
      const permanentDi = [`deathOrDismemberment${type}`, `dateOfDismemberment${type}`, `provideDetailsDismemberment${type}`];
      permanentDi.forEach((res) => {
        if (this.getData(res, '', this.step2)) {
          disablityData.push(
            {
              name: this.getData(res, 'label', this.step2)['label'],
              value: this.getData(res, '', this.step2)
            }
          );
        }
      });
    }
    if (e && disablityData.length > 0) {
      const array = [{
        name: 'Accidental Death or Dismemberment',
        value: 'heading'
      }];

      disablityData = [...array, ...disablityData];
    }
    return disablityData;
  }

  /**
   * To capture data from the Critical Illness section.
   * @param e
   * @returns Array of data related to Critical Illness section.
   * will try to redise the lines of code using captureData().
   */
  criticalIllness(e?) {
    const illnessList = ['natureOfIllness', 'dateOfonset', 'prescribedMedications'];
    let illnessData = [];
    illnessList.forEach((res) => {
      if (this.getData(res, '', this.step2)) {
        illnessData.push(
          {
            name: this.getData(res, 'label', this.step2)['label'],
            value: this.getData(res, '', this.step2)
          }
        );
      }
    });

    if (e && illnessData.length > 0) {
      const array = [{
        name: 'Critical Illness',
        value: 'heading'
      }];
      illnessData = [...array, ...illnessData];
    }
    return illnessData;
  }

  /**
   * To capture data for Critical Illness hospitalization.
   * @returns
   */
  getCriticalHospital() {
    let personalAccidentArray = [];
    const array = [];
    if (this.dataStoreService.get(this.step2)['uiData']['criticalIllnessHospital'] === 'Yes' && this.dataStoreService.get(this.step2)['uiData']['criticalIllnessHospital'] !== null) {
      array.push(
        {
          name: this.getData('criticalIllnessHospital', 'label', this.step2)['label'],
          value: this.getData('criticalIllnessHospital', '', this.step2),
        }
      )
      const nonBagNoEMp = ['nameOfClinic', 'criticalIllnessAdmissionDate', 'criticalIllnessAdmissionTime', 'CriticalIllnessDischargeDate', 'criticalIllnessDischargeTime'];
      const hospitalArray = this.buildDetailsWithNull({ mainUIFieldName: 'addCriticalTreatmentMain', fieldNames: nonBagNoEMp, conditionalFieldName: 'criticalIllnessHospital' });
      personalAccidentArray = [...array, ...hospitalArray];
    } else {
      personalAccidentArray.push({
        name: this.getData('criticalIllnessHospital', 'label', this.step2)['label'],
        value: this.getData('criticalIllnessHospital', '', this.step2),
      });
    }
    return personalAccidentArray.filter(e => (e.name !== undefined));
  }

  /**
   * To capture Critical Illness physician.
   * @returns
   */
  getPhysicianInfo() {
    const uiData = this.dataStoreService.get(this.step2).uiData;
    let data = [];
    if (uiData['physicianInfo'] === 'Yes' && uiData['physicianInfo'] !== null) {
      data = [...this.captureData('physicianInfo'), ...this.hospitalPhyInfo('a')];
    } else {
      data.push({
        name: this.getData('physicianInfo', 'label', this.step2)['label'],
        value: this.getData('physicianInfo', '', this.step2),
      });
    }
    return data.filter(e => (e.name !== undefined));
  }

  /**
   * To capture Critical Illness physician details.
   * @returns
   */
  hospitalPhyInfo(e?) {
    const travelInsurance = Utils.getFieldFromStructure(this.dataStoreService.get(this.step2).uiStructure, 'addPhysicianMain').fields;
    let personalAccidentArray = [];
    const uiData = this.dataStoreService.get(this.step2).uiData;
    if (uiData['physicianInfo'] === 'Yes') {
      travelInsurance.forEach((card, i) => {
      card.fields.forEach((data) => {
        if (i > 0 && !e) {
          personalAccidentArray.push({
            'name': '',
            'value': ''
          });
        }
        data?.fields?.forEach((item) => {
          if (item.name.match('physicianLocationLookup')) {
            if (this.getData(item.name, '', this.step2)) {
              personalAccidentArray.push(
                {
                  name: this.getData(item.name, 'label', this.step2)['label'],
                  value: this.dataStoreService.checkAutoComplete(this.getData(item.name + 'val', '', this.step2) ? this.getData(item.name + 'val', '', this.step2) : this.getData(item.name, '', this.step2).formatted_address ? this.getData(item.name, '', this.step2).formatted_address : this.getData(item.name, '', this.step2))
                }
              );
            }
          }
          else {
            personalAccidentArray.push({
              'name': this.getData(item.name, 'label', this.step2)['label'],
              'value': this.getData(item.name, '', this.step2)
            });
          }
        });
      });
      });
    } else {
      personalAccidentArray = [];
    }
    return personalAccidentArray.filter(element => !(element.value === null && element.name === undefined));
  }

  /**
   * To capture data from the Hospital Cash section.
   * @param e
   * @returns Array of data related to Hospital Cash section.
   */
  hospitalCash(e?) {
    return this.hospitalCashData();
  }

  /**
   * To capture data from the Fracture or Dislocation section.
   * @param e
   * @returns Array of data related to Fracture or Dislocation section.
   */
  fractureOrDislocation(type) {
    let fractureDislocation = [];
    const array = [{
      name: 'Fracture or Dislocation',
      value: 'heading'
    }];
    fractureDislocation = [...array, ...this.captureData(`sustainFracture${type}`), ...this.fractureDislocation(`addFracture${type}Main`, `sustainFracture${type}`),
    ...this.captureData(`sustainDislocation${type}`), ...this.fractureDislocation(`addDislocation${type}Main`, `sustainDislocation${type}`)];
    return fractureDislocation.filter(e => (e.name !== undefined));
  }

  otherDeath(type, e?) {
    return this.otherDeathData(type, e);
  }

  getUploadDetails(step) {
    return this.getUploadDetailsData(step);
  }
}
